export interface TraitDef {
  key: string;
  abbr: string;
}

export interface TraitGroup {
  label: string;
  traits: TraitDef[];
}

export const breedingValueGroups: TraitGroup[] = [
  {
    label: 'Calving & Reproductive',
    traits: [
      { key: 'calving_ease', abbr: 'CE' },
      { key: 'birth_weight', abbr: 'BW' },
      { key: 'gestation_length', abbr: 'GL' },
      { key: 'scrotal_size', abbr: 'SS' },
    ],
  },
  {
    label: 'Growth & Performance',
    traits: [
      { key: 'weaning_weight', abbr: 'WW' },
      { key: 'yearling_weight', abbr: 'YW' },
      { key: 'day_200_weight', abbr: '200D' },
      { key: 'day_400_weight', abbr: '400D' },
      { key: 'day_600_weight', abbr: '600D' },
    ],
  },
  {
    label: 'Maternal',
    traits: [
      { key: 'milk', abbr: 'MLK' },
      { key: 'total_maternal', abbr: 'TM' },
      { key: 'maternal_weaning_weight', abbr: 'MWW' },
    ],
  },
  {
    label: 'Carcass & Composition',
    traits: [
      { key: 'carcass_weight', abbr: 'CW' },
      { key: 'marbling', abbr: 'MBL' },
      { key: 'intramuscular_fat', abbr: 'IMF' },
      { key: 'fat_thickness', abbr: 'FT' },
      { key: 'ribeye_area', abbr: 'REA' },
      { key: 'eye_muscle_area', abbr: 'EMA' },
      { key: 'rump_fat', abbr: 'RF' },
      { key: 'retail_beef_yield', abbr: 'RBY' },
    ],
  },
];

export const allTraitKeys = breedingValueGroups.flatMap(g => g.traits.map(t => t.key));
